import React from "react";
var d = new Date();
var currYear = d.getFullYear();

function Footer() {
  return (
    <React.StrictMode>
      <div className="copyright-details">
        <div className="about-social-icon text-center">
          <ul className="about-social">
            <li className="wow fadeIn" data-wow-delay=".8s">
              <a href="https://twitter.com/ArvTax?t=X__CRmGbJSScqUWIMQMjRw&s=09" target="newtab">
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </a>
            </li>
            <li className="wow fadeIn" data-wow-delay=".6s">
              <a
                href="https://www.linkedin.com/in/ca-harshareddy"
                target="newtab"
              >
                <i className="fa fa-linkedin" aria-hidden="true"></i>
              </a>
            </li>
            <li className="wow fadeIn" data-wow-delay=".2s">
              <a href="https://wa.me/+917995162535" target="newtab">
                <i className="fa fa-whatsapp" aria-hidden="true"></i>
              </a>
            </li>
            <li className="wow fadeIn" data-wow-delay=".4s">
              <a
                href="https://instagram.com/arv_taxcorp?igshid=MzNlNGNkZWQ4Mg==/"
                target="newtab"
              >
                <i className="fa fa-instagram" aria-hidden="true"></i>
              </a>
            </li>
            <li className="wow fadeIn" data-wow-delay="1.2s">
              <a href="https://youtube.com/@arvtaxcorpindla6544" target="newtab">
                <i className="fa fa-youtube" aria-hidden="true"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="copyright">
          <h3>&copy; {currYear}, ARV Tax Corp | Indla & Associates | Chartered Accountants |  All Rights Reserved.</h3>
          
          {/* <h3>&copy; {currYear}, Made with ❤️ by CA Harsha Reddy.</h3> */}
        </div>
      </div>
    </React.StrictMode>
  );
}

export default Footer;
